<template>
  <ListItem :title="localGroup.title" :action-url="localGroup.publicPath" :color-index="colorIndexForType('group')">
    <template #post-title>
      <div class="member-count">
        {{ i18n.formattedCount('public.groups.members_count', localGroup.memberCount) }}
      </div>
    </template>
    <template #content>
      <div class="content">
        <div>{{ displayDescription }}</div>
      </div>
    </template>
    <template #action-button-text>
      {{ i18n.t('local_chapters.show.join') }}
    </template>
  </ListItem>
</template>

<script>
import ListItem from './list-item'
import truncate from 'lodash/truncate'

const LOCAL_CHAPTER_DESCRIPTION_TRUNCATED_LENGTH = 100

export default {
  components: { ListItem },
  props: {
    localGroup: {
      type: Object,
      required: true
    }
  },
  computed: {
    displayDescription() {
      return truncate(this.localGroup.description, { 'length': LOCAL_CHAPTER_DESCRIPTION_TRUNCATED_LENGTH })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
}

.member-count {
  font-size: 16px;
  font-weight: bold;
}

::v-deep(.stat .stat-units) {
  font-size: 12px;
}
</style>
